<template>
  <TheHeader>
    <div class="contents-wrapper-01">
      <div class="bbs_title">
        로그
        <slot name="buttons" />
        <a-button size="large" type="link" shape="circle" icon="reload" @click="refreshLogs" />
        <a-button
          style="margin: 5px;"
          shape="round"
          type="dashed"
          v-if="isPC"
          class="fl-right"
          @click="$router.go(-1)"
          icon="rollback"
        >뒤로가기</a-button>
      </div>
      <div class="acc-content-wrapper type2">
        <slot />
        <p style="text-align: right; margin-top: 0.5em;">
          <a-icon type="arrow-right" />
          <b>&nbsp;총합:</b>
          &nbsp;
          {{ ($store.state.saib.totalLog || 0).toLocaleString() }}원
        </p>
      </div>
    </div>
  </TheHeader>
</template>
<script>
import { mapActions } from "vuex";
import TheHeader from "../TheLayout/TheHeader";

export default {
  name: "TheLog",
  components: { TheHeader },
  methods: mapActions(["refreshLogs"])
};
</script>